var _defs, _circle, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ab97b5b7-1632-4e84-9265-91969c21cbcb",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.15,
    height: 54.15,
    viewBox: "0 0 54.15 54.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-c91c7066-d496-4fdc-9ecd-c1d89bcc9186 {\n        fill: none;\n      }\n\n      .uuid-c91c7066-d496-4fdc-9ecd-c1d89bcc9186, .uuid-b6509ba1-55bd-45b4-9dc3-895c63da64ef {\n        stroke: #fffdf1;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.03px;\n      }\n\n      .uuid-b6509ba1-55bd-45b4-9dc3-895c63da64ef {\n        fill: #323850;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-b6509ba1-55bd-45b4-9dc3-895c63da64ef",
    cx: 27.07,
    cy: 27.07,
    r: 26.06
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-c91c7066-d496-4fdc-9ecd-c1d89bcc9186",
    points: "27.07 37.6 27.07 16.54 17.96 25.66 27.07 16.54 36.21 25.66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLegal);
export default __webpack_public_path__ + "static/media/arrowLegal.ad5f320a5e385deee545339f41770db0.svg";
export { ForwardRef as ReactComponent };